import React from "react";
import { Box, Typography } from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import SpeedIcon from "@mui/icons-material/Speed";
import styles from "./insightsCard.module.scss";

interface InsightsCardProps {
  type: "risk" | "leakage" | "bottleneck";
  title: string;
  description: string;
}

const InsightsCard: React.FC<InsightsCardProps> = ({ type, title, description }) => {
  const getIcon = () => {
    switch (type) {
      case "risk":
        return <WarningIcon className={styles.icon} />;
      case "leakage":
        return <TrendingDownIcon className={styles.icon} />;
      case "bottleneck":
        return <SpeedIcon className={styles.icon} />;
      default:
        return null;
    }
  };

  return (
    <Box className={`${styles.insightsCard} ${styles[type]}`}>
      {getIcon()}
      <Box className={styles.content}>
        <Typography variant="body1" className={styles.title}>
          {title}
        </Typography>
        <Typography variant="body2" className={styles.description}>
          {description}
        </Typography>
      </Box>
    </Box>
  );
};

export default InsightsCard;

